import { render, staticRenderFns } from "./review-file-list.vue?vue&type=template&id=277c458c&scoped=true&"
import script from "./review-file-list.vue?vue&type=script&lang=js&"
export * from "./review-file-list.vue?vue&type=script&lang=js&"
import style0 from "./review-file-list.vue?vue&type=style&index=0&id=277c458c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277c458c",
  null
  
)

export default component.exports